import React, { type ReactNode } from "react";
import { DesktopNavigationHeader } from "src/components/DesktopNavigationControls";

export const DASHBOARD_RIGHT_SIDEBAR_ROOT_ID = "dashboard-right-sidebar-root";

const DashboardShell = ({
  header,
  sidebar,
  footer,
  children,
  onClick,
}: {
  header: ReactNode;
  sidebar?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  onClick?: () => void;
}) => {
  // Outer is pinned to exactly the viewport so the dashboard header always
  // stays put. The inner content area is the ONLY scroll surface (flex-1 +
  // min-h-0 so it can shrink inside the flex column) and `overscroll-contain`
  // prevents scroll-chaining: when the user reaches the bottom of the content
  // we don't let the wheel bleed into the body and pull the header out of view.
  return (
    <div className="bg-background flex flex-col h-screen" onClick={onClick}>
      <DesktopNavigationHeader>{header}</DesktopNavigationHeader>
      <div className="flex-1 min-h-0 flex relative">
        {sidebar && <div className="hidden min-[850px]:block">{sidebar}</div>}
        <div className="flex-1 min-h-0 overflow-auto overscroll-contain">
          <div className="min-h-full self-end flex flex-col">
            {children}
            {footer}
          </div>
        </div>
        {/* Global overlays can portal docked tools here so they participate in
            layout instead of covering the page. Empty by default. */}
        <div id={DASHBOARD_RIGHT_SIDEBAR_ROOT_ID} className="relative min-h-0 shrink-0" />
      </div>
    </div>
  );
};

export default React.memo(DashboardShell);
